import React from "react";
import "./Policy.css";

const TermsConditions = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Terms & Conditions</h1>

        <p>
          By accessing and using the Zynvert website, you agree to comply with
          the following terms and conditions.
        </p>

        <h2>Use of Website</h2>

        <p>
          You agree to use this website only for lawful purposes and in
          accordance with these terms.
        </p>

        <h2>Product Information</h2>

        <p>
          We strive to ensure product descriptions and prices are accurate,
          however errors may occur.
        </p>

        <h2>Pricing</h2>

        <p>Prices may change without prior notice.</p>

        <h2>Limitation of Liability</h2>

        <p>
          Zynvert Technologies shall not be liable for any indirect damages
          resulting from the use of this website.
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;
